import { ReactNode, useState, useEffect } from "react";
import { AuthContext } from "./AuthContext";
import { AUTH_STATE_KEY, TOKEN_KEY } from '../../constants/auth';

interface AuthProviderProps {
  children: ReactNode;
}

export const AuthProvider: React.FC<AuthProviderProps> = ({ children }) => {
  const [state, setState] = useState<boolean>(() => {
    const storedAuthState = localStorage.getItem(AUTH_STATE_KEY);
    return storedAuthState ? JSON.parse(storedAuthState) : false;
  });

  const [token, setToken] = useState<string | null>(() => {
    return localStorage.getItem(TOKEN_KEY);
  });

  const setAuthenticated = (isAuthenticated: boolean, authToken?: string) => {
    setState(isAuthenticated);
    localStorage.setItem(AUTH_STATE_KEY, JSON.stringify(isAuthenticated));

    if (!authToken) {
      localStorage.removeItem(TOKEN_KEY);
      return;
    }
    
    setToken(authToken);
    localStorage.setItem(TOKEN_KEY, authToken);
  };

  const logout = () => {
    setAuthenticated(false);
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(AUTH_STATE_KEY);
  };

  useEffect(() => {
    const storedAuthState = localStorage.getItem(AUTH_STATE_KEY);
    const storedToken = localStorage.getItem(TOKEN_KEY);

    if (storedAuthState) {
      setState(JSON.parse(storedAuthState));
    }

    if (storedToken) {
      setToken(storedToken);
    }
  }, []);

  return (
    <AuthContext.Provider value={{ isAuthenticated: state, setAuthenticated, token, logout }}>
      {children}
    </AuthContext.Provider>
  );
};
